import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Venue = () => {
  return (
    <React.Fragment>
      <SEO title="Virtual Meeting | ICSI 2024" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Virtual Meeting"
        content="For Participants"
        contentTwo="Virtual Meeting"
        linkage="/"

      />

      <EmptyTwo>
        {/* <div className="entry-content title-center"> 
        <h3>The specific venue information will be announced later. </h3>
        </div> */}

        <div className="entry-content">

          <h4>How to participate online</h4>
          <br></br>
          <div className="crucial2">
            The ICSI Organizing Committee decided to use Tencent Conference as the software for online conference.
            Countries and regions other than China can use VooV Meeting to participate. Room numbers for meetings are listed below.
            <br></br>

          </div>

          <br></br>
          <table>
            <thead>
              <tr>
                <th > Room Name</th>
                <th > Room Code </th>
                <th > Agenda </th>
                <th > Time</th>
              </tr>
              <tr>
                <td>ICSI2024 Online Information Desk</td>
                <td> 912-731-184   </td>
                <td>Information Desk
                </td>
                <td>
                  13:00-18:00, August 23th
                </td>

              </tr>
              <tr>
                <td>ICSI2024 Opening Ceremony</td>
                <td>526-374-324   </td>
                <td>  Opening Ceremony </td>
                <td  > 08:30-12:00, August 24th</td>
              </tr>
              <tr>
              <td> ICSI2024 Online Room 1</td>
              <td> 	267-211-974  </td>
              <td>  Parallel Session 4  </td>
              <td rowSpan={2} > 14:00 - 18:00, August 24th
              <br></br>09:00 - 12:00, August 25th
              </td>
              </tr>
              <tr>
              <td>  ICSI2024 Online Room 2</td>
              <td>  221-606-280  </td>
              <td>  Parallel Session 5 </td>
              </tr>
              </thead>
              </table>


          <h3>How to Submit video</h3>
          <br></br>
          <div >
            The ICSI&apos;2024 conference supports the submission of speech videos to participate in the conference. If your speech time conflicts with your schedule, you can submit a 15-minute video, which will be played by the conference team.
            <br></br>
            <br></br>

            The video should be around 15 minutes long, using a PowerPoint presentation to introduce the content of your paper. The language should be English, and the resolution should be 720P or higher. We recommend using Tencent Meeting(VooV Meeting) or Zoom to record the video.
            <br></br>
            <br></br>
            The recorded video needs to be uploaded to the network disk and submitted to the conference team in the form of a link. It is recommended to use Alibaba Cloud or Baidu Cloud. And It is recommended to use onedrive in countries and regions other than China. The video needs to be submitted to the conference team two days in advance. 
            You can submit the video by sending the video link via email to the conference committee at icsi2024@iasei.org.
            <br></br>
            <br></br>
            <strong>
              Please note: Authors submitting videos are encouraged to participate in the opening ceremony and award ceremony of the conference.
            </strong>
          </div>

        </div>
        <div className="entry-content">
          <p>&nbsp;</p>
          <p>&nbsp;</p>

        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Venue;
